module.exports = {"createText":"新增角色","pageTitleText":"角色管理","roleName":"角色名稱","status":"狀態","action":"操作","downloadSystemCerts":"下載系統憑證"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-TW/rolesmanage.json
// module id = SaJw
// module chunks = 3